module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-super-container",
    attrs: {
      "id": "options-tabs-super-container"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLeftShadow),
      expression: "showLeftShadow"
    }],
    staticClass: "box-shadow-container left box-shadow-container-options-left"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/left-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll left"
    }
  })]), _c('div', {
    staticClass: "tabs-container",
    style: ('max-width: ' + _vm.tabsContainerMaxWidth + 'px'),
    attrs: {
      "id": "coin-filter-container"
    }
  }, [_c('div', {
    staticClass: "tabs filter-label"
  }, _vm._l((_vm.listOfCoins), function(o, index) {
    return _c('div', {
      staticClass: "coin-filter",
      class: {
        'selected': o.active
      },
      on: {
        "click": function($event) {
          return _vm.select(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.coin))]), _c('img', {
      attrs: {
        "src": o.logo,
        "alt": o.coin + ' logo'
      }
    })])
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRightShadow),
      expression: "showRightShadow"
    }],
    staticClass: "box-shadow-container right box-shadow-container-options-right"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/right-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06e26a80","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_coin_filter.vue
// module id = 355
// module chunks = 1